import React, { useEffect, useRef, useState } from 'react';
import { ActivityIndicator, Animated, StyleSheet, Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { commandBusy } from '../runtime/mobile/testWorkerClient';
import { colors, radius, spacing, typography } from '../config/theme';

// A small "the app is working" pill that fades in whenever a command is in
// flight, so a slow request (opening a shift, sending photos) reads as busy,
// not frozen. Non-blocking — it never eats taps.
export default function BusyOverlay() {
  const insets = useSafeAreaInsets();
  const [busy, setBusy] = useState(commandBusy.active());
  const opacity = useRef(new Animated.Value(0)).current;
  const linger = useRef(null);

  useEffect(() => commandBusy.subscribe((isBusy) => {
    if (isBusy) {
      if (linger.current) { clearTimeout(linger.current); linger.current = null; }
      setBusy(true);
    } else {
      // Keep it up a beat so a burst of quick calls doesn't flicker.
      linger.current = setTimeout(() => setBusy(false), 400);
    }
  }), []);

  useEffect(() => {
    Animated.timing(opacity, { toValue: busy ? 1 : 0, duration: 180, useNativeDriver: true }).start();
  }, [busy, opacity]);

  return (
    <Animated.View pointerEvents="none" style={[styles.wrap, { top: insets.top + spacing.sm, opacity }]}>
      <View style={styles.pill}>
        <ActivityIndicator size="small" color={colors.primary} />
        <Text style={styles.text}>Секундочку…</Text>
      </View>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  wrap: { position: 'absolute', left: 0, right: 0, alignItems: 'center', zIndex: 9999 },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    backgroundColor: colors.surfaceCard,
    borderWidth: 1,
    borderColor: colors.borderStrong,
    borderRadius: radius.full,
    paddingLeft: spacing.md,
    paddingRight: spacing.md + 2,
    paddingVertical: 8,
    shadowColor: '#4A3F2A',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.18,
    shadowRadius: 12,
    elevation: 6,
  },
  text: { ...typography.caption, color: colors.textSecondary, fontWeight: '700' },
});
